import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { Button, Tooltip } from 'antd';
import { styled } from '@xstyled/styled-components';
import { styleVariables } from '@lib/common';
import { getAnswerGradingVisualStatus } from '../../utils/get-answer-grading-visual-status';
import { getAnswerStatusColorTooltip } from '../../utils/get-answer-status-color-tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var QuestionItem = styled(Button)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  padding: ", ";\n  width: 37px;\n  height: 37px;\n\n  border: ", ";\n\n  border-radius: ", ";\n\n  color: ", ";\n\n  background-color: ", ";\n\n  ", "\n"])), styleVariables.padding.medium, function (props) {
  if (props.$neutralizeStatus) {
    return "".concat(styleVariables.borderWidth.small, " solid ").concat(props.theme.color.borderDefault);
  } // Priority 1: Active (cho Essay - hasGraded)


  if (props.active) {
    return "".concat(styleVariables.borderWidth.small, " solid ").concat(props.theme.color.borderActive);
  } // Priority 2: Skipped (đã nộp nhưng không có answer)


  if (props.isSkipped || props.$visualStatus === 'skipped') {
    return "".concat(styleVariables.borderWidth.small, " solid ").concat(props.theme.color.borderError);
  }

  if (props.$visualStatus === 'manuallyAwarded') {
    return "".concat(styleVariables.borderWidth.small, " solid ").concat(styleVariables.colors.gold1);
  } // Priority 3: Has answer


  if (props.hasAnswer) {
    return props.isCorrect ? "".concat(styleVariables.borderWidth.small, " solid ").concat(props.theme.color.borderSuccess) : "".concat(styleVariables.borderWidth.small, " solid ").concat(props.theme.color.borderError);
  } // Priority 4: Default (chưa nộp hoặc chưa có answer)


  return "".concat(styleVariables.borderWidth.small, " solid ").concat(props.theme.color.borderDefault);
}, styleVariables.borderRadius.medium, function (props) {
  if (props.$neutralizeStatus) {
    return props.theme.color.fontColorDefault;
  }

  if (props.active) {
    return props.theme.color.fontColorActive;
  }

  if (props.isSkipped || props.$visualStatus === 'skipped') {
    return props.theme.color.fontColorError;
  }

  if (props.$visualStatus === 'manuallyAwarded') {
    return styleVariables.colors.gold1;
  }

  if (props.hasAnswer) {
    return props.isCorrect ? props.theme.color.fontColorSuccess : props.theme.color.fontColorError;
  }

  return props.theme.color.fontColorDefault;
}, function (props) {
  if (props.$neutralizeStatus) {
    return props.theme.color.bgDefault;
  }

  if (props.active) {
    return props.theme.color.bgActive;
  }

  if (props.isSkipped || props.$visualStatus === 'skipped') {
    return props.theme.color.bgError;
  }

  if (props.$visualStatus === 'manuallyAwarded') {
    return '#FFF7E6';
  }

  if (props.hasAnswer) {
    return props.isCorrect ? props.theme.color.bgSuccess : props.theme.color.bgError;
  }

  return props.theme.color.bgDefault;
}, function (props) {
  return props.$neutralizeStatus && "\n      &&:disabled,\n      &&:disabled:hover {\n        color: ".concat(props.theme.color.fontColorDefault, ";\n        background-color: ").concat(props.theme.color.bgDefault, ";\n        border-color: ").concat(props.theme.color.borderDefault, ";\n      }\n    ");
});
export var PanelButton = function PanelButton(_ref) {
  var onClick = _ref.onClick,
      isSkipped = _ref.isSkipped,
      hasAnswer = _ref.hasAnswer,
      isCorrect = _ref.isCorrect,
      score = _ref.score,
      hasGraded = _ref.hasGraded,
      active = _ref.active,
      disabled = _ref.disabled,
      neutralizeStatus = _ref.neutralizeStatus,
      questionIndex = _ref.questionIndex,
      tooltipText = _ref.tooltipText,
      _ref$showTooltip = _ref.showTooltip,
      showTooltip = _ref$showTooltip === void 0 ? true : _ref$showTooltip,
      label = _ref.label;
  var visualStatus = getAnswerGradingVisualStatus({
    isSkipped: isSkipped,
    hasAnswer: hasAnswer,
    isCorrect: isCorrect,
    score: score,
    hasGraded: hasGraded
  });

  var getTooltipText = function getTooltipText() {
    var colorTooltipLabel = {
      correct: (label === null || label === void 0 ? void 0 : label.correctAnswerQuestion) || (label === null || label === void 0 ? void 0 : label.correct),
      incorrect: (label === null || label === void 0 ? void 0 : label.wrongAnswer) || (label === null || label === void 0 ? void 0 : label.incorrect),
      customGrade: (label === null || label === void 0 ? void 0 : label.customGrade) || (label === null || label === void 0 ? void 0 : label.graded),
      skipped: label === null || label === void 0 ? void 0 : label.skipped,
      essay: (label === null || label === void 0 ? void 0 : label.essayQuestion) || (label === null || label === void 0 ? void 0 : label.essay) || (label === null || label === void 0 ? void 0 : label.graded)
    }; // Essay question (blue)

    if (active) {
      return getAnswerStatusColorTooltip('essay', colorTooltipLabel);
    }

    if (isSkipped || visualStatus === 'skipped') {
      return getAnswerStatusColorTooltip('skipped', colorTooltipLabel);
    }

    if (visualStatus === 'correct') {
      return getAnswerStatusColorTooltip('correct', colorTooltipLabel);
    }

    if (visualStatus === 'manuallyAwarded') {
      return getAnswerStatusColorTooltip('manuallyAwarded', colorTooltipLabel);
    }

    if (hasAnswer && isCorrect === false) {
      return getAnswerStatusColorTooltip('incorrect', colorTooltipLabel);
    }

    return label === null || label === void 0 ? void 0 : label.awaitingGrading;
  };

  var questionItemButton = /*#__PURE__*/_jsx(QuestionItem, {
    size: "small",
    isSkipped: isSkipped,
    hasAnswer: hasAnswer,
    isCorrect: isCorrect,
    $visualStatus: visualStatus,
    $neutralizeStatus: neutralizeStatus,
    active: active,
    disabled: disabled,
    onClick: onClick,
    children: questionIndex
  });

  var tooltipTrigger = disabled ? /*#__PURE__*/_jsx("span", {
    style: {
      display: 'inline-flex'
    },
    children: questionItemButton
  }) : questionItemButton;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: showTooltip ? /*#__PURE__*/_jsx(Tooltip, {
      title: tooltipText || label && getTooltipText(),
      children: tooltipTrigger
    }) : questionItemButton
  });
};